<ion-label>Type of Reservation</ion-label>
<ion-grid size="auto">
  <ion-row>
    <ion-col
      size="4"
      class="ion-text-center"
      *ngFor="let kitchen of sortBy('posicaoTela'); let i = index"
    >
      <ion-card
        class="card"
        [ngClass]="{ selected: selectedItem === i }"
        (click)="selectItem(i, kitchen)"
      >
        <ion-card-content class="card__content">
          <ion-img [src]="kitchen.icone" class="card__icon" />
        </ion-card-content>
        <ion-card-header class="card__header">
          <ion-card-title class="card__title">{{
            kitchen.nome
          }}</ion-card-title>
        </ion-card-header>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-grid>
